module.exports = __webpack_public_path__ + "img/zk_logo.7e284954.svg";